import script from "./DocZapView.vue?vue&type=script&setup=true&lang=js"
export * from "./DocZapView.vue?vue&type=script&setup=true&lang=js"

import "./DocZapView.vue?vue&type=style&index=0&id=1b4e78c8&lang=scss"

const __exports__ = script;

export default __exports__